import { render, staticRenderFns } from "./BaseSelectType.vue?vue&type=template&id=1a9a46b8&scoped=true"
import script from "./BaseSelectType.vue?vue&type=script&lang=js"
export * from "./BaseSelectType.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectType.vue?vue&type=style&index=0&id=1a9a46b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a46b8",
  null
  
)

export default component.exports